import { JoinPoint, JoinPointContext } from './../../../aop';
import { BusinessObjectBase } from './../../../bo';
import { ModelBase } from './../../../model';

export class PropertyChangingJoinPoint extends JoinPoint<PropertyChangingJoinPointContext> { }

export class PropertyChangingJoinPointContext extends JoinPointContext {
    public constructor(
        sender: BusinessObjectBase<ModelBase>,
        public readonly model: ModelBase,
        public readonly propertyName: string,
        public readonly newValue: any
    ) {
        super(sender);
    }
}
